import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordComponent } from './password/password.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [PasswordComponent],
  imports: [
    CommonModule,FormsModule,ReactiveFormsModule
  ]
})
export class PasswordModule { }
